var _style, _circle, _path, _path2, _path3, _circle2, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconKolonoskopia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D70000;}\r\n\t.st1{fill:#009245;}\r\n\t.st2{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st3{stroke:#000000;stroke-miterlimit:10;}\r\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-width:1.5;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#000000;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#000000;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st9{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st10{fill:#004B87;}\r\n\t.st11{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st12{fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 15,
    cy: 15,
    r: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M13.325,4.492c0,0-0.518,3.47,3.318,5.474c1.633,0.853,3.288,2,3.428,4.404 c0.066,1.133-0.299,3.045-1.799,4.264"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M11.998,4.575c0,0-0.912,3.345,0.935,5.702c1.203,1.534,1.997,3.793,1.081,5.973 c-1.426,3.394-4.915,3.71-6.871,3.71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M6.793,22.057c0,0,4.642,3.344,9.616,2.345c3.828-0.769,5.572-3.473,6.494-5.899 c0.811-2.135,0.547-6.697-2.193-9.008c-1.439-1.213-3.685-1.513-4.731-2.223c-0.467-0.317-1.452-1.576-1.452-2.779"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 17.254,
    cy: 19.409,
    r: 1.232
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 15.995,
    y1: 19.137,
    x2: 13.728,
    y2: 19.267
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 16.07,
    y1: 19.966,
    x2: 13.133,
    y2: 21.468
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 16.576,
    y1: 20.601,
    x2: 15.495,
    y2: 22.368
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKolonoskopia);
export default __webpack_public_path__ + "static/media/icon_kolonoskopia.82edfcd18f39665121bad70429b7977e.svg";
export { ForwardRef as ReactComponent };